export enum Permissions {

    // READ tekmirio application
    PermissionInternalTekmirioApplicationReadMy = 'permission.internal.tekmirio.application.read;my',
    PermissionInternalTekmirioApplicationReadMy_org = 'permission.internal.tekmirio.application.read;my_org',
    PermissionInternalTekmirioApplicationReadAll = 'permission.internal.tekmirio.application.read;all',

    // READ location application
    PermissionInternalLocationApplication = 'permission.internal.location.application.read',

    // READ location application
    PermissionInternalLocationApplicationReadMy = 'permission.internal.location.application.read;my',
    PermissionInternalLocationApplicationReadMy_org = 'permission.internal.location.application.read;my_org',
    PermissionInternalLocationApplicationReadAll = 'permission.internal.location.application.read;all',

    // READ location application modification request
    PermissionInternalLocationApplicationModificationRequestReadMy = 'permission.internal.location.application.modification.request.read;my',
    PermissionInternalLocationApplicationModificationRequestReadMy_org = 'permission.internal.location.application.modification.request.read;my_org',
    PermissionInternalLocationApplicationModificationRequestReadAll = 'permission.internal.location.application.modification.request.read;all',

    // READ professional application
    PermissionInternalProfessionalsApplicationReadMy = 'permission.internal.professionals.application.read;my',
    PermissionInternalProfessionalsApplicationReadMy_org = 'permission.internal.professionals.application.read;my_org',
    PermissionInternalProfessionalsApplicationReadAll = 'permission.internal.professionals.application.read;all',

    // READ professional application modification request
    PermissionInternalProfessionalsApplicationModificationRequestReadMy = 'permission.internal.professionals.application.modification.request.read;my',
    PermissionInternalProfessionalsApplicationModificationRequestReadMy_org = 'permission.internal.professionals.application.modification.request.read;my_org',
    PermissionInternalProfessionalsApplicationModificationRequestReadAll = 'permission.internal.professionals.application.modification.request.read;all',


    // READ REST APPLICATIONS   
    PermissionInternalRestApplicationsReadMy_org = 'permission.internal.rest.applications;my_org',
    PermissionInternalRestApplicationsReadAll = 'permission.internal.rest.applications;all',

    // CREATE LOCATION APPLICATION
    PermissionInternalLocationApplicationCreateMy_org = 'permission.internal.location.application.create;my_org',
    PermissionInternalLocationApplicationCreateAll = 'permission.internal.location.application.create;all',

    // CREATE LOCATION APPLICATION MODIFICATION REQUEST
    PermissionInternalLocationApplicationModificationRequestCreateMy_org = 'permission.internal.location.application.modification.request.create;my_org',
    PermissionInternalLocationApplicationModificationRequestCreateAll = 'permission.internal.location.application.modification.request.create;all',

    // CREATE LOCATION APPLICATION FORCE
    PermissionInternalLocationApplicationCreateForceMy_org = 'permission.internal.location.application.create.force;my_org',
    PermissionInternalLocationApplicationCreateForceAll = 'permission.internal.location.application.create.force;all',

    // CREATE PROFESSIONAL APPLICATION
    PermissionInternalProfessionalsApplicationCreateMy_org = 'permission.internal.professionals.application.create;my_org',
    PermissionInternalProfessionalsApplicationCreateAll = 'permission.internal.professionals.application.create;all',

    // CREATE PROFESSIONAL APPLICATION MODIFICATION REQUEST
    PermissionInternalProfessionalsApplicationModificationRequestCreateMy_org = 'permission.internal.professionals.application.modification.request.create;my_org',
    PermissionInternalProfessionalsApplicationModificationRequestCreateAll = 'permission.internal.professionals.application.modification.request.create;all',

    PermissionInternalLocationApplicationRespondMy_org = 'permission.internal.location.application.respond;my_org',
    PermissionInternalLocationApplicationRespondAll = 'permission.internal.location.application.respond;all',

    PermissionExternalLocationReadMy = 'permission.external.location.read;my',
    PermissionExternalProfessionalReadMy = 'permission.external.professional.read;my',
    PermissionExternalTekmirioReadMy = 'permission.external.tekmirio.read;my',

    PermissionExternalLocationApplicationCreateMy = 'permission.external.location.application.create;my',
    PermissionExternalLocationApplicationReadMy = 'permission.external.location.application.read;my',

    PermissionExternalProfessionalApplicationCreateMy = 'permission.external.professional.application.create;my',
    PermissionExternalTekmirioApllicationCreateMy = 'permission.external.tekmirio.application.create;my',

    PermissionExternalLocationApplicationModificationCreateMy = 'permission.external.location.application.modification.create;my',
    PermissionExternalProfessionalApplicationModificationCreateMy = 'permission.external.professional.application.modification.create;my',
    PermissionExternalTekmirioApplicationModificationCreateMy = 'permission.external.tekmirio.application.modification.create;my',

    PermissionExternalLocationFavoritesReadMy = 'permission.external.location.favorites.read;my',
    PermissionExternalLocationFavoritesUpdateMy = 'permission.external.location.favorites.update;my',

    PermissionExternalProfessionalsFavoritesReadMy = 'permission.external.professionals.favorites.read;my',
    PermissionExternalProfessionalsFavoritesUpdateMy = 'permission.external.professionals.favorites.update;my',

    PermisionInternalPDFUpdate = "permission.internal.pdf_json.update"
}

export enum PermissionsManageLocProf {
    PermissionInternalManageApplicationReadMyOrg = 'permission.internal.manage.application.read;my_org',
    PermissionInternalManageApplicationReadAll = 'permission.internal.manage.application.read;all',

    PermissionInternalManagePublishLocationCreateMyOrg = 'permission.internal.manage.publish.location.create;my_org',
    PermissionInternalManagePublishLocationCreateAll = 'permission.internal.manage.publish.location.create;all',

    PermissionInternalManageProfessionalReadMyOrg = 'permission.internal.manage.professional.read;my_org',
    PermissionInternalManageProfessionalReadAll = 'permission.internal.manage.professional.read;all',

    PermissionInternalManagePublishProfessionalCreateMyOrg = 'permission.internal.manage.publish.professional.create;my_org',
    PermissionInternalManagePublishProfessionalCreateAll = 'permission.internal.manage.publish.professional.create;all',
}


export enum PermissionsManageInternalUsers {
    PermissionInternalUsersManageReadMyOrg = 'permission.internal.users.manage.read;my_org',
    PermissionInternalUsersManageReadAll = 'permission.internal.users.manage.read;all',

    PermissionsInternalUsersManageCreateMyOrg = 'permission.internal.users.manage.create;my_org',
    PermissionsInternalUsersManageCreateAll = 'permission.internal.users.manage.create;all',

    PermissionInternalUsersDelete = 'permission.internal.users.delete'
}

export enum PermissionsManageExternalUsers {
    PermissionInternalManageExternalUserListRead = 'permission.internal.manage.external.user.list.read',
    PermissionInternalManageExternalUserBasicInfoRead = 'permission.internal.manage.external.user.basicinfo.read',
    PermissionInternalManageExternalUserNote = 'permission.internal.manage.external.user.note',
    PermissionInternalManageExternalUserBlockUnblock = 'permission.internal.manage.external.user.block.unblock',
    PermissionInternalManageExternalUserChangeRole = 'permission.internal.manage.external.user.change.role'
}

export enum PermissionsManageFilmOffice {
    PermissionsInternalFilmOfficeReadMyOrg = 'permission.internal.film.office.read;my_org',
    PermissionsInternalFilmOfficeReadAll = 'permission.internal.film.office.read;all',

    PermissionsInternalFilmOfficeCreateMyOrg = 'permission.internal.film.office.create;my_org',
    PermissionsInternalFilmOfficeCreateAll = 'permission.internal.film.office.create;all',
}

export enum PermissionsRolesManagement {
    PermissionsInternalRoleManagementRead = 'permission.internal.role.management.read',
    PermissionsInternalRoleManagementCreate = 'permission.internal.role.management.create',
}


export enum PermissionsApplicationFormsManagement {
    PermissionsInternalApplicationFormsDigitalizationQuestionaryManagement = 'permission.internal.application.digitalization.questionary.management',
    PermissionsInternalApplicationFormsDigitalizationManagement = 'permission.internal.application.digitalization.management',
    PermissionsInternalApplicationFormsQuestionaryManagement = 'permission.internal.application.questionary.management',
    PermissionsInternalApplicationFormsQuestionaryEducationManagement = 'permission.internal.application.questionary.education.management',
    PermissionsInternalApplicationFormsEducationManagement = 'permission.internal.application.education.management',
    PermissionsInternalApplicationFormsInvestmentManagement = 'permission.internal.application.investment.management',
    PermissionsInternalApplicationFormsOthersManagement = 'permission.internal.application.others.management',
}

export enum PermissionsFormBuilderApplicationResultsRead {
    PermissionsInternalFormBuilderApplicationResultsReadAllApplication = 'permission.internal.formbuilder.all.application.results',
    PermissionsInternalFormBuilderApplicationResultsReadDigitalizationQuestionary = 'permission.internal.formbuilder.digitalization.questionary.results',
    PermissionsInternalFormBuilderApplicationResultsReadInvestment = 'permission.internal.formbuilder.investment.results',
    PermissionsInternalFormBuilderApplicationResultsReadEducationQuestionary = 'permission.internal.formbuilder.education.questionary.results',
}


export enum InteroperabilityPermissions {

    PermissionInternalAadeAfm = 'permission.internal.aade.afm.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητα ΑΑΔΕ με ΑΦΜ για αναζήτηση στοιχείων φυσικού προσώπου-μη φυσικού προσώπου
    PermissionInternalAadeName = 'permission.internal.aade.name.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητα ΑΑΔΕ με επώνυμο-πατρώνυμο για αναζήτηση στοιχείων φυσικού προσώπου
    PermissionInternalAadeAdt = 'permission.internal.aade.adt.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητα ΑΑΔΕ με ΑΔΤ για αναζήτηση στοιχείων φυσικού προσώπου

    PermissionsInternalEParavoloForea = 'permission.internal.eparavolo.forea.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες E-ΠΑΡΑΒΟΛΟ Στοιχεία Φορέα
    PermissionsInternalEParavoloPerson = 'permission.internal.eparavolo.person.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες E-ΠΑΡΑΒΟΛΟ Παράβολα
    PermissionsInternalEParavoloInfo = 'permission.internal.eparavolo.info.read;my', //Μπορώ να δω και να χρησιμοποιήσω E-ΠΑΡΑΒΟΛΟ Ανάκτηση Πληροφορίας
    PermissionsInternalEParavoloInfoApplicant = 'permission.internal.eparavolo.applicant.read;my', //Μπορώ να δω και να χρησιμοποιήσω E-ΠΑΡΑΒΟΛΟ Ανάκτηση Στοιχείων Αιτούντος
    PermissionsInternalEParavoloParavoloType = 'permission.internal.eparavolo.type.read;my', //Μπορώ να δω και να χρησιμοποιήσω E-ΠΑΡΑΒΟΛΟ Ανάκτηση Τύπου Παραβόλου
    PermissionsInternalEParavoloParavoloState = 'permission.internal.eparavolo.state.read;my', //Μπορώ να δω και να χρησιμοποιήσω E-ΠΑΡΑΒΟΛΟ Ανάκτηση Κατάστασης Παραβόλου
    PermissionsInternalEParavoloCreate = 'permission.internal.eparavolo.create;my', //Μπορώ να δω και να χρησιμοποιήσω E-ΠΑΡΑΒΟΛΟ Δημιουργια Παραβόλου

    PermissionsInternalGemiVerification = 'permission.internal.gemi.verification.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες ΓΕΜΗ Επιβεβαίωση ΓΕΜΗ
    PermissionsInternalGemiAdminGroup = 'permission.internal.gemi.admin.group.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες ΓΕΜΗ Στοιχεία Διοικητικού Συμβουλίου
    PermissionsInternalGemiBasicInfo = 'permission.internal.gemi.basic.info.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες ΓΕΜΗ Βασικές Πληροφορίες από Μητρώο ΓΕΜΗ
    PermissionsInternalIdikaInfo = 'permission.internal.idika.info.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες ΗΔΙΚΑ Εύρεση Προσωπικών Στοιχείων
    PermissionsInternalIdikaAmka = 'permission.internal.idika.amka.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες ΗΔΙΚΑ Εύρεση ΑΜΚΑ
    PermissionsInternalIdikaPaaypa = 'permission.internal.idika.paaypa.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες ΗΔΙΚΑ Εύρεση ΠΑΑΥΠΑ
    PermissionsInternalBankVerification = 'permission.internal.bank.verification.read;my', //Μπορώ να δω και να χρησιμοποιήσω Διαλειτουργικότητες Τράπεζες Επιβεβαίωση με Τράπεζες

    PermissionsInternalAfeIssue = 'permission.internal.afe.issue.read;my',
    PermissionsInternalAfeValidation = 'permission.internal.afe.validation.read;my',
    PermissionsInternalAfeVersion = 'permission.internal.afe.version.read;my',
}

export enum OptionsPermissions {
    PermissionsInternalOptionsReviewInteroperability = 'permission.internal.options.review.interoperability',
    PermissionsInternalOptionsManageApis = 'permission.internal.options.manage.apis',
    PermissionsInternalOptionsStartOA = 'permission.internal.options.start.oa',
    PermissionsInternalOptionsEmailEditor = 'permission.internal.options.email.editor'
}

export enum MassivePermissions {
    PermissionInternalApplicationsSubmissionsMassiveAll = 'permission.internal.applications.submissions.massive;all',
    PermissionInternalApplicationsSubmissionsMassiveMyOrg = 'permission.internal.applications.submissions.massive;my_org'
}


export enum FromScratchPermissions {
    PermissionsInternalApplicationFromScratchMyOrg = 'permission.internal.application.from.scratch;my_org',
    PermissionsInternalApplicationFromScratchAll = 'permission.internal.application.from.scratch;all'
}

export enum AdminExternalResources {
    PermissionsInternalOmekaView = 'permission.internal.omeka.view',
    PermissionsInternalWordpressView = 'permission.internal.wordpress.view',
    PermissionsInternalStatisticsView = "permission.internal.statistics.view"
}

export enum AdminAssignApplicationPermissions {
    PermissionsInternalAssignLocationAll = 'permission.internal.assign.location:all',
    PermissionsInternalAssignLocationMyOrg = 'permission.internal.assign.location:my_org',
    PermissionsInternalAssignProfessionalAll = 'permission.internal.assign.professional:all',
    PermissionsInternalAssignProfessionalMyOrg = 'permission.internal.assign.professional:my_org',

}


export enum AdminAnswerApplicationPermissions {
    PermissionAnswerLocationMyOrg = 'permission.internal.answer.location:my_org',
    PermissionAnswerLocationAll = 'permission.internal.answer.location:all',
    PermissionAnswerProfessionalMyOrg = 'permission.internal.answer.professional:my_org',
    PermissionAnswerProfessionalAll = 'permission.internal.answer.professional:all',
}

export enum IntExt {
    Internal = 'internal',
    External = 'external'
}
